exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Column___3s3y6 { \n  display: flex;  \n  flex-direction: column; \n} \n\n.Title___2c8MM {  \n  font-size: var(--font-size-sans-large); \n  margin-bottom: 0.5rem;  \n} \n\n.ReleaseNotesLink___2PYAH { \n  color: var(--color-button-active);  \n}\n\n.Version___34HO3 {\n  color: var(--color-bridge-version-number);\n  font-weight: bold;\n}\n\n.NpmCommand___2lHg1 {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.25rem 0.25rem 0.25rem 0.5rem;\n  background-color: var(--color-bridge-version-npm-background);\n  color: var(--color-bridge-version-npm-text);\n  margin: 0;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-large);\n}\n\n.Paragraph___3H72v {\n  margin: 0.5rem 0;\n}\n\n.Link___5TAEG {\n  color: var(--color-link);\n}", ""]);

// exports
exports.locals = {
	"Column": "Column___3s3y6",
	"Title": "Title___2c8MM",
	"ReleaseNotesLink": "ReleaseNotesLink___2PYAH",
	"Version": "Version___34HO3",
	"NpmCommand": "NpmCommand___2lHg1",
	"Paragraph": "Paragraph___3H72v",
	"Link": "Link___5TAEG"
};